import qs from 'qs';
import forOwn from 'lodash/forOwn';

export function parseQuery(query: string) {
    const parameters = {};

    forOwn(qs.parse(query), (value, key) => {
        parameters[key.toLowerCase()] = value;
    });

    return parameters;
}

export function stringifyQuery(query: Object) {
    const result = qs.stringify(query);

    return result ? `?${result}` : '';
}
